import React from 'react';
import ReactDOM from 'react-dom/client'; // or 'react-dom' for older React versions
import './index.css'; // Or your main CSS file
import App from './App';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// reportWebVitals();